import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'

export default function () {
  const formStore = useFormStore()
  const authStore = useAuthStore()

  const res = {
    isUAECitizen: authStore.isUAECitizen,
    isLoginUserSelected: formStore.form.values.isLoginUserSelected,
    selectedSponsor: formStore.form.values?.selectedSponsor,
    requireMobileNumberEdit: formStore.form.values.requireMobileNumberEdit,
    requireEmailEdit: formStore.form.values.requireEmailEdit,
    isFamilyMembersSelected: formStore.form.values.isFamilyMembersSelected,
    isOutsideUAE: formStore.form.values.isOutsideUAE,
    motherRegisteredAtFamilyBook: formStore.form.values.motherRegisteredAtFamilyBook,
    mobileNumbers: formStore.extraMap.mobileNumbers,
    isEmailValidated: formStore.extraMap.isEmailValidated,
    editMobileNumber: formStore.form.values.editMobileNumber,
    enableAddressControls: formStore.form.values.enableAddressControls,
    mobileNumbers_length: formStore.extraMap.mobileNumbers?.length,
    currentEmail: formStore.form.values.currentEmail,
    newEmail: formStore.form.values.newEmail,
    newMobileNumber: formStore.form.values.newMobileNumber,
    currentNationalityId: formStore.form.values.currentNationalityId,
    isNormalFileNumber: formStore.form.values.isNormalFileNumber,
    oneTimePasswordForEmail: formStore.form.values.oneTimePasswordForEmail,
    oneTimePassword: formStore.form.values.oneTimePassword,
    isFourPart: formStore.form.values.isNormalFileNumber === 1,
    hasEntryTransactions: formStore.form.values.hasEntryTransactions
  }

  return res
}
